import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { PrivacyPolicy } from 'features/PrivacyPolicy'

export default function User() {
  const { t } = useTranslation()

  return (
    <div>
      <Head>
        <title>{t('privacy-policy:page-title')}</title>
        <meta name="title" content={t('privacy-policy:meta-title')} />
        <meta name="description" content={t('privacy-policy:meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/privacy-policy" />
      </Head>

      <main>
        <PrivacyPolicy />
      </main>
    </div>
  )
}
